import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNav() {
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="w-full px-4 md:px-6 py-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索精彩分类
          </h2>
          <p className="text-foreground-500 text-sm max-w-md mx-auto">
            八个精选分类，总有一个你喜欢的
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => handleClick(cat.slug)}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center transition-all duration-200 ${
                cat.color === 'primary'
                  ? 'bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50'
                  : 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50'
              }`}>
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <div className="text-center">
                <span className="block text-sm font-medium text-foreground-800 whitespace-nowrap">{cat.name}</span>
                <span className="block text-xs text-foreground-400 mt-0.5">{cat.count.toLocaleString()}个视频</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}